import { render, staticRenderFns } from "./ExtendedDataPropertyDefinition.vue?vue&type=template&id=12f45e7c&scoped=true&"
import script from "./ExtendedDataPropertyDefinition.vue?vue&type=script&lang=js&"
export * from "./ExtendedDataPropertyDefinition.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedDataPropertyDefinition.vue?vue&type=style&index=0&id=12f45e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f45e7c",
  null
  
)

export default component.exports